(function () {
  'use strict';
  var CblSchedaProdottoDossierCtrl = function (
    $scope,
    $state,
    $stateParams,
    $filter,
    schedaDossierSrvc,
    uiGridConstants,
    $sce,
    commonUtilities,
    CONSTANTS,
    messaggiFctr,
    deskSrvc,
    labelSrvc,
    userSrvc
  ) {
    if ($scope === undefined) {
      return;
    }

    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$filter = $filter;
    this.schedaDossierSrvc = schedaDossierSrvc;
    this.$sce = $sce;
    this.commonUtilities = commonUtilities;
    this.messaggiFctr = messaggiFctr;
    this.posizione = {};
    this.totaliConti = {};
    this.finSpinner = {
      customerData: false
    };
    this.dataContratto = null;
    this.deskSrvc = deskSrvc;
    this.userSrvc = userSrvc;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;
    $scope.urlIcons = './common/assets/img/schedaCliente';
    // Lettura dei parametri di input
    this.numeroRapporto = this.$stateParams.finCodiceRapporto;
    if (this.numeroRapporto && this.numeroRapporto.length < 6) {
      var leftPadding = 6 - this.numeroRapporto.length;
      for (var index = 0; index < leftPadding; index++) {
        this.numeroRapporto = '0' + this.numeroRapporto;
      }
    }

    this.dossierDivisa = $stateParams.finDivisa;
    this.dossierCambio = $stateParams.finCambio;
    this.dossierDecimali = $stateParams.finDecimali;
    this.isDossierEffeBtnEnabled = userSrvc.abilitato(
      'EffeReportisticaVisibile'
    );
    this.isPunteggioESGEnabled = /*userSrvc.abilitato('EsgConsulenzaAttiva')*/ true;
    this.customerPunteggioEsg = 0;
    this.customerDettagliEsg = {};
    this.customerpunteggioSinteticoESG = null;

    var self = this;

    this.esgVisibile = function () {
      return userSrvc.abilitato(CONSTANTS.ABILITAZIONI.ESG_CONSULENZA_ATTIVA);
    };

    if (self.deskSrvc.isDesk) {
      labelSrvc.labelsPronte.then(function () {
        self.deskSrvc.aggiungiEntry(
          labelSrvc.getLabel('dettaglio.dossier.titolo')
        );
      });
    }

    if (self.isDossierEffeBtnEnabled) {
      self.schedaDossierSrvc
        .promisereportEffe($stateParams.finCodiceRapporto)
        .then(function (response) {
          self.isDossierEffeBtnEnabled = response.data.result !== null;
        });
    }

    // Inizializzazione del DTO - rapporto
    if (this.numeroRapporto !== null && this.numeroRapporto !== '') {
      //this.getSchedaDossierDTO(this.numeroRapporto);
      self.finSpinner.customerData = true;
      self.schedaDossierSrvc
        .promiseCustomerData(self.$stateParams.finCodiceRapporto)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.posizione = {};
              return;
            }
            self.posizione = response.data;
            if (!!response.data.esgCliente) {
              self.customerDettagliEsg =
                response.data.esgCliente.tipoCalcoloEsg === 'D'
                  ? response.data.esgCliente.dettagliEsg
                  : null;
              self.customerpunteggioSinteticoESG =
                response.data.esgCliente.sinteticoEsg.punteggioSintetico;
            }
            self.schedaDossierSrvc
              .promiseTotaliConti(self.$stateParams.finCodiceRapporto)
              .then(function (response) {
                if (self.messaggiFctr.processaResponse(response)) {
                  self.totaliConti = {};
                  return;
                }
                self.totaliConti = response.data.result;
                self.schedaDossierSrvc.schedaDossierDTO = response.data.result;

                self.schedaDossierSrvc.datasourceItalia =
                  response.data.result.contiInEuro;
                self.gridOptionsControvalore.data =
                  self.schedaDossierSrvc.datasourceItalia;
                self.gridOptionsControvalore.height =
                  self.commonUtilities.calculateHeightUIGridComponent(
                    self.gridOptionsControvalore
                  );

                self.schedaDossierSrvc.datasourceEstero =
                  response.data.result.contiInEuro.contiEsteri;
                self.gridOptionsControvaloreEstero.data =
                  self.schedaDossierSrvc.datasourceEstero;
                self.gridOptionsControvaloreEstero.height =
                  self.commonUtilities.calculateHeightUIGridComponent(
                    self.gridOptionsControvaloreEstero
                  );

                self.schedaDossierSrvc.datasourceDerivatiEuro =
                  response.data.result.contiInEuro.contiInDerivatiEuro;
                self.gridOptionsControvaloreDerivatiEuro.data =
                  self.schedaDossierSrvc.datasourceDerivatiEuro;
                self.gridOptionsControvaloreDerivatiEuro.height =
                  self.commonUtilities.calculateHeightUIGridComponent(
                    self.gridOptionsControvaloreDerivatiEuro
                  );

                self.schedaDossierSrvc.datasourceDerivatiEstero =
                  response.data.result.contiInEuro.contiInDerivatiEstero;
                self.gridOptionsControvaloreDerivatiEstero.data =
                  self.schedaDossierSrvc.datasourceDerivatiEstero;
                self.gridOptionsControvaloreDerivatiEstero.height =
                  self.commonUtilities.calculateHeightUIGridComponent(
                    self.gridOptionsControvaloreDerivatiEstero
                  );
              });
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.finSpinner.customerData = false;
        });
    }
    // Costanti
    this.TAB_LIST = [
      {
        title: 'Composizione',
        url:
          CONSTANTS.BASE_ROOT +
          CONSTANTS.COMPONENTS_PATH +
          'schedaDossier/states/finProductViewDossier.states.composizione.html',
        reasonVisible: true,
        template: false
      },
      {
        title: 'Movimenti',
        url:
          CONSTANTS.BASE_ROOT +
          CONSTANTS.COMPONENTS_PATH +
          'schedaDossier/states/finProductViewDossier.states.movimenti.html',
        reasonVisible: true,
        template: false
      },
      {
        title: 'Controvalore',
        url:
          CONSTANTS.BASE_ROOT +
          CONSTANTS.COMPONENTS_PATH +
          'schedaDossier/states/finProductViewDossier.states.controvalore.html',
        reasonVisible: true,
        template: false
      },
      {
        title: 'Pratiche consulenza attiva',
        url: false,
        reasonVisible: false,
        template: true
      },
      {
        title: 'Grafico saldo periodo',
        url:
          CONSTANTS.BASE_ROOT +
          CONSTANTS.COMPONENTS_PATH +
          'schedaDossier/states/finProductViewDossier.states.graficoSaldo.html',
        reasonVisible: false,
        template: false
      }
    ];

    // Tab corrente
    this.currentTab = sessionStorage.getItem(
      'fin_schedaDossier_' +
        this.schedaDossierSrvc.schedaDossierDTO.NdgIntestatario
    )
      ? JSON.parse(
          sessionStorage.getItem(
            'fin_schedaDossier_' +
              this.schedaDossierSrvc.schedaDossierDTO.NdgIntestatario
          )
        )
      : this.TAB_LIST[0];

    // Reset della ricerca
    //this.formReset();
    this.formMovimentiReset();
    this.searchField = null;

    // Variabil di errore
    this.errorStarDate = false;
    this.errorEndDate = false;
    this.movementsNotFound = false;

    //variabile per grafico
    this.highchartsDS = null;

    this.getDatacontratto = function () {
      self.schedaDossierSrvc
        .promiseDataRicontrattualizzazione(self.numeroRapporto)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.posizione = {};
              return;
            }
            self.dataContratto = response.data.result;
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        );
    };

    this.userSrvc.abilitazioniPronte.then(function () {
      if (
        self.userSrvc.abilitato(CONSTANTS.ABILITAZIONI.RICONTRATTUALIZZAZIONE)
      ) {
        self.dataContratto = '-';
        self.getDatacontratto();
      }
    });

    // #region Costruzione della tabella ui-grid

    var onlyValueAggregation = function (aggregation) {
      aggregation.rendered = aggregation.value;
    };

    this.apriConsulenzaBase = function (event, tipo) {
      event.preventDefault();
      event.stopPropagation();

      sessionStorage.setItem('isFromSchedaDossier', true);

      $state.go(self.deskSrvc.isDesk ? 'home.sceltadossier' : 'saldodossier', {
        finServizio: tipo,
        ndg: $stateParams.ndg,
        finCodiceRapporto: $stateParams.finCodiceRapporto
      });
    };

    this.apriCashflow = function (event) {
      event.preventDefault();
      event.stopPropagation();

      $state.go(self.deskSrvc.isDesk ? 'home.cashflow' : 'cashflow', {
        finCodiceRapporto: $stateParams.finCodiceRapporto,
        ndg: $stateParams.ndg,
        finDivisa: $stateParams.finDivisa,
        finCambio: $stateParams.finCambio,
        finDecimali: $stateParams.finDecimali
      });
    };
    this.apriEstrattoConto = function (event) {
      event.preventDefault();
      event.stopPropagation();

      $state.go(self.deskSrvc.isDesk ? 'home.estrattoConto' : 'estrattoConto', {
        finCodiceRapporto: $stateParams.finCodiceRapporto,
        ndg: $stateParams.ndg,
        finDivisa: $stateParams.finDivisa,
        finCambio: $stateParams.finCambio,
        finDecimali: $stateParams.finDecimali
      });
    };

    this.apriRicontrattualizzazione = function (event) {
      event.preventDefault();
      event.stopPropagation();

      $state.go(
        self.deskSrvc.isDesk
          ? 'home.ricontrattualizzazione'
          : 'ricontrattualizzazione',
        {
          finCodiceRapporto: $stateParams.finCodiceRapporto,
          rapporto: $stateParams.finCodiceRapporto,
          ndg: $stateParams.ndg,
          idPratica: '',
          tipo: 'DOS'
        }
      );
    };
    // #endregion

    // #region Griglie del controvalore

    var gridColumnsControvalore = [
      {
        cellTooltip: true,
        headerTooltip: true,
        displayName: 'TipologiaConto',
        field: 'tipologiaConto'
      },
      {
        cellTooltip: true,
        headerTooltip: true,
        displayName: 'Rapporto',
        field: 'rapporto',
        cellTemplate:
          '<div class="ui-grid-cell-contents"><a href="javascript:;" ng-click="grid.appScope.redirectRapporto(row.entity[col.field])">{{row.entity[col.field]}}</a></div>'
      },
      {
        cellTooltip: true,
        headerTooltip: true,
        displayName: 'Saldo contabile',
        field: 'saldoContabile',
        cellTemplate:
          '<div class="ui-grid-cell-contents right" ng-class="{ red:row.entity[col.field] < 0 }">{{row.entity[col.field] | number: 2}} &euro;</div>'
      },
      {
        cellTooltip: true,
        headerTooltip: true,
        displayName: 'Saldo disponibile',
        field: 'saldoDisponibile',
        cellTemplate:
          '<div class="ui-grid-cell-contents right" ng-class="{ red:row.entity[col.field] < 0 }">{{row.entity[col.field] | number: 2}} &euro;</div>'
      },
      {
        cellTooltip: true,
        headerTooltip: true,
        displayName: 'Fido',
        field: 'fido',
        cellTemplate:
          '<div class="ui-grid-cell-contents right" ng-class="{ red:row.entity[col.field] < 0 }">{{row.entity[col.field] | number: 2}} &euro;</div>'
      },
      {
        cellTooltip: true,
        headerTooltip: true,
        displayName: 'Non Contabilizzato',
        field: 'saldoNonContabilizzato',
        cellTemplate:
          '<div class="ui-grid-cell-contents right" ng-class="{ red:row.entity[col.field] < 0 }">{{row.entity[col.field] | number: 2}} &euro;</div>'
      }
    ];

    this.gridOptionsControvalore = {
      enableSorting: true,
      enableColumnMenus: false,
      enableFiltering: false,

      enableGridMenu: false,
      gridMenuShowHideColumns: false,
      enableGrouping: false,

      enableCellEditing: false,
      enableCellEditOnFocus: false,
      treeRowHeaderAlwaysVisible: false,

      enablePagination: false,
      enablePaginationControls: false,
      paginationPageSize: 10,

      enableRowSelection: false,
      multiSelect: false,
      enableRowHeaderSelection: false,

      showGridFooter: false,

      rowHeight: 30,

      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
      columnDefs: gridColumnsControvalore,

      onRegisterApi: function (gridApi) {
        //self.gridApi = gridApi;
      },
      data: []
    };
    this.gridOptionsControvalore.height =
      commonUtilities.calculateHeightUIGridComponent(
        this.gridOptionsControvalore
      );

    this.gridOptionsControvaloreEstero = jQuery.extend(
      {},
      this.gridOptionsControvalore
    );
    this.gridOptionsControvaloreDerivatiEuro = jQuery.extend(
      {},
      this.gridOptionsControvalore
    );
    this.gridOptionsControvaloreDerivatiEstero = jQuery.extend(
      {},
      this.gridOptionsControvalore
    );

    // #endregion

    this.$scope.redirectRapporto = function (numeroRapporto) {
      self.commonUtilities.openContoCorrente(
        self.$stateParams.ndg,
        numeroRapporto,
        'schedaContoCorrenteDossier'
      );
    };

    this.$scope.controvaloreHelp = $sce.trustAsHtml(
      "Per ulteriori dettagli consultare la sezione 'Controvalore'"
    );

    this.spinner = this.commonUtilities.getUrlSpinner($scope);
    this.internalLoading = false;
  };

  CblSchedaProdottoDossierCtrl.prototype = {
    formMovimentiReset: function () {
      this.schedaDossierSrvc.inputFormMovimenti = {
        startDate: null,
        endDate: null,
        isin: null,
        descrizione: null
      };
      this.schedaDossierSrvc.movimenti = null;
      this.searchField = null;
      this.errorStarDate = false;
      this.errorEndDate = false;
      this.movementsNotFound = false;
    },

    // Cerca movimenti
    getCurrentAccountMovements: function () {
      var startDate = Date.parse(
        this.schedaDossierSrvc.inputFormMovimenti.startDate
      );
      var endDate = Date.parse(
        this.schedaDossierSrvc.inputFormMovimenti.endDate
      );
      var enabled =
        !isNaN(startDate) &&
        startDate !== null &&
        !isNaN(endDate) &&
        endDate !== null;

      if (isNaN(startDate) || startDate === null) {
        this.errorStarDate = true;
      }
      if (isNaN(endDate) || endDate === null) {
        this.errorEndDate = true;
      }
      if (enabled && startDate > endDate) {
        this.errorStarDate = false;
        this.errorEndDate = true;
        return;
      }

      if (enabled) {
        this.errorStarDate = false;
        this.errorEndDate = false;

        var self = this;
        var input = {
          Rapporto: this.numeroRapporto,
          DataInizio: new Date(startDate),
          DataFine: new Date(endDate),
          CodiceIsin: this.schedaDossierSrvc.inputFormMovimenti.isin
            ? this.schedaDossierSrvc.inputFormMovimenti.isin
            : null,
          Descrizione: this.schedaDossierSrvc.inputFormMovimenti.descrizione
            ? this.schedaDossierSrvc.inputFormMovimenti.descrizione
            : null
        };
        this.getDossierMovements(input);
      }
    },

    // Determina se ci sono movimenti
    hasMovements: function () {
      if (
        this.schedaDossierSrvc.movimenti === null ||
        this.schedaDossierSrvc.movimenti === undefined
      ) {
        return false;
      }
      var count = this.schedaDossierSrvc.movimenti.length;
      if (count === null || count === undefined) {
        return false;
      }
      var flag = count > 0;
      return flag;
    },

    // Recupero controvalore
    //getDossierValue: function () {
    //    //this.getDossierValueService(this.numeroRapporto);
    //},

    //Recupero valori per grafico saldo
    getDossierBalances: function () {
      CblBrioLoader.showLoader();
      var startDate = Date.parse(
        this.schedaDossierSrvc.inputFormGraficoSaldo.startDate
      );
      var endDate = Date.parse(
        this.schedaDossierSrvc.inputFormGraficoSaldo.endDate
      );
      var enabled =
        !isNaN(startDate) &&
        startDate !== null &&
        !isNaN(endDate) &&
        endDate !== null;

      if (isNaN(startDate) || startDate === null) {
        this.errorStarDate = true;
      }
      if (isNaN(endDate) || endDate === null) {
        this.errorEndDate = true;
      }
      if (enabled && startDate > endDate) {
        this.errorStarDate = false;
        this.errorEndDate = true;
        CblBrioLoader.hideLoader();
        return;
      }

      if (enabled) {
        this.errorStarDate = false;
        this.errorEndDate = false;

        var self = this;
        var input = {
          Rapporto: this.numeroRapporto,
          DataInizio: new Date(startDate),
          DataFine: new Date(endDate)
        };
        this.getDossierBalancesService(input);
      }
    },

    getCustomer: function () {
      return {
        ndg: this.schedaDossierSrvc.schedaDossierDTO.NdgIntestatario,
        idAnagrafica:
          this.schedaDossierSrvc.schedaDossierDTO.IdAnagraficaIntestatario,
        naturaGiuridica:
          this.schedaDossierSrvc.schedaDossierDTO.NaturaGiuridicaIntestatario
      };
    },
    // #region Funzioni per la gestione dei tab
    changeTab: function (tab) {
      sessionStorage.setItem(
        'fin_schedaDossier_' +
          this.schedaDossierSrvc.schedaDossierDTO.NdgIntestatario,
        JSON.stringify(tab)
      );
      this.currentTab = tab;
    },

    isActiveTab: function (tabUrl) {
      return tabUrl == this.currentTab.url;
    },

    changeTab2: function (tab) {
      this.currentTab_2 = tab;
    },

    isActiveTab2: function (tabUrl) {
      return tabUrl == this.currentTab_2.url;
    },
    // #endregion

    getSeries: function () {
      this.schedaDossierSrvc.chart.series = ['Movimenti'];
    },

    getSource: function () {
      CblBrioLoader.showLoader();
      this.schedaDossierSrvc.chart.labels = [];
      this.schedaDossierSrvc.chart.dataset = [];
      var currentDataset = [];
      this.highchartsDS = [];

      if (this.schedaDossierSrvc.saldoDatasource !== null) {
        for (var index in this.schedaDossierSrvc.saldoDatasource) {
          var item = this.schedaDossierSrvc.saldoDatasource[index];
          var date = new Date(item.DataSaldo);
          var x =
            this.commonUtilities
              .decodeMonth(date.getMonth())
              .substr(0, 3)
              .toUpperCase() +
            ' ' +
            date.getFullYear();
          var y = item.Saldo;

          currentDataset.push(y);

          var highchartsPoint = [];
          highchartsPoint.push(
            Date.UTC(
              date.getFullYear(),
              date.getMonth(),
              date.getDate(),
              date.getHours(),
              date.getMinutes(),
              date.getSeconds()
            )
          );
          highchartsPoint.push(y);
          this.highchartsDS.push(highchartsPoint);

          this.schedaDossierSrvc.chart.labels.push(x);
        }
        this.schedaDossierSrvc.chart.dataset.push(currentDataset);
      }
    },

    getDossierMovements: function (input) {
      this.schedaDossierSrvc.allMovements = new Array();
      this.schedaDossierSrvc.movimenti = new Array();
      this.schedaDossierSrvc.datasource = new Array();
      this.gridOptions.data = new Array();

      var serviceUrl =
        this.commonUtilities.MF_INFO.CustomerData.url() +
        'Dossier/GetDossierMovements';
      var serviceParams = input;
      var parentThis = this;
      var successCallback = function (self, data) {
        if (data !== null) {
          self.schedaDossierSrvc.allMovements = data;
          self.schedaDossierSrvc.movimenti = data;
          self.schedaDossierSrvc.datasource = data;

          self.gridOptions.data = self.schedaDossierSrvc.movimenti;
          self.resetPagination();
          self.movementsNotFound =
            self.schedaDossierSrvc.movimenti.length === 0;
        }
        self.internalLoading = false;
      };
      var errorCallback = function (self, error) {
        self.internalLoading = false;
      };
      var showLoaderService = false;
      this.internalLoading = true;
      this.commonUtilities.executeHttpPostService(
        serviceUrl,
        serviceParams,
        parentThis,
        showLoaderService,
        successCallback,
        errorCallback
      );
    },

    getDossierBalancesService: function (input, parent, successCallback) {
      var serviceUrl =
        this.commonUtilities.MF_INFO.CustomerData.url() +
        'Dossier/GetDossierBalances';
      var serviceParams = input;
      var parentThis = this;
      var successCallback = function (self, data) {
        self.schedaDossierSrvc.saldoDatasource = data;
        self.getSource();
      };
      var showLoaderService = true;
      this.commonUtilities.executeHttpPostService(
        serviceUrl,
        serviceParams,
        parentThis,
        showLoaderService,
        successCallback,
        null
      );
    }
  };
  CblSchedaProdottoDossierCtrl.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$filter',
    'SchedaDossierSrvc',
    'uiGridConstants',
    '$sce',
    'CommonUtilitiesSrvc',
    'FIN_CONSTANTS',
    'FinMessaggiFctr',
    'FinDeskSrvc',
    'FinLabelSrvc',
    'FinUserSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'schedaDossier/schedaDossier.html'
    );
  };
  TemplateUrl.$inject = ['FIN_CONSTANTS'];

  var SchedaDossierComponent = {
    bindings: {
      sceltaDossierState: '@',
      visualizzaRaccomandazioneState: '@',
      modificaRaccomandazioneState: '@',
      nuovaRaccomandazioneState: '@',
      valutazioneRaccomandazioneState: '@',
      modificaRichiestaState: '@',
      nuovaRichiestaState: '@',
      visualizzaRichiestaState: '@'
    },
    controller: CblSchedaProdottoDossierCtrl,
    controllerAs: 'schedaProdottoDossierCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.finanza.mf')
    .component('finanzaSchedaDossier', SchedaDossierComponent);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/schedaDossier/schedaDossierCtrl.js
 ** module id = 40
 ** module chunks = 1 2
 **/